import { render } from "./BookEntry.vue?vue&type=template&id=61db4cb9"
import script from "./BookEntry.vue?vue&type=script&lang=js"
export * from "./BookEntry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__